import React from "react"
import AcceptSuggestionButton from "../DinnerPlanButtons/AcceptSuggestionButton/AcceptSuggestionButton"
import DeclineSuggestionButton from "../DinnerPlanButtons/DeclineSuggestionButton/DeclineSuggestionButton"
import { connect } from "react-redux"
import "./SuggestedRestaurant.scss"
import {
  acceptSuggestion,
  declineSuggestion,
  saveSuggestionEvent,
  validateUserAddress,
  setSuggestion,
} from "../../redux/actionCreators/planDinnner"
import _ from "../../utils/lodashUtils"
import { SUGGESTION_STATES } from "../../constants/commons"
import {
  FirebaseContext,
  FIREBASE_STATE_KEYS,
  FirebaseService,
} from "../../firebase"
import { emitter } from "../../utils/emitter"
import { CUSTOM_EVENTS } from "../../constants/commons"
import { withRouter } from "react-router"
import { getPartnerNameorNickName } from "../../utils/helpers"

const SuggestedRestaurant = (props) => {
  const { partner, user, suggesting, setSuggestion } = props
  const { partnerState, userState, dateState } = React.useContext(
    FirebaseContext
  )
  const firebaseUserAddress = _.get(
    userState,
    "userDetails.address.user_address",
    ""
  )
  const firebasePartnerAddress = _.get(
    partnerState,
    "userDetails.address.user_address",
    ""
  )
  const allRestaurants = _.get(dateState, FIREBASE_STATE_KEYS.RESTAURANTS, {})
  let pendingRestaurantSuggestion = {}
  const suggestedRestaurant = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT,
    {}
  )
  if (
    suggestedRestaurant[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
    SUGGESTION_STATES.PENDING
  ) {
    pendingRestaurantSuggestion = suggestedRestaurant
  }
  const restaurantMetaData = _.get(
    allRestaurants,
    `${pendingRestaurantSuggestion[FIREBASE_STATE_KEYS.RESTAURANT_ID]}`,
    {}
  )

  const dollars = () => {
    if (restaurantMetaData)
      return [...Array(restaurantMetaData.price_rating)].map((e, i) => (
        <span key={i}>$</span>
      ))
  }
  const firebaseActions = (action) => async () => {
    // if accepted, clear users' suggestions and push the restaurant to acceptedRestaurant key.
    await FirebaseService.write(
      null,
      `${FirebaseService.getDefaultPath()}${user.uuid}/${[
        FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT,
      ]}`
    )
    await FirebaseService.write(
      {
        ...pendingRestaurantSuggestion,
      },
      `${FirebaseService.getDefaultPath()}${[
        FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
      ]}`
    )
    await FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.SUGGESTION_STATE]: action,
      },
      `${FirebaseService.getDefaultPath()}${partner.uuid}/${[
        FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT,
      ]}`
    )

    await FirebaseService.setActiveRoute("/confirm-date")
    props.history.push("/confirm-date")
    //save to admin dashboard on accept
    saveToAdminDashboard(action)
  }

  const saveToAdminDashboard = (action) => {
    const suggestedValue = {
      suggestedBy: partner.username,
      suggestedTo: user.username,
      type: "restaurant",
      id: suggestedRestaurant.restaurantId,
      menu: "",
      isAccepted: action === SUGGESTION_STATES.ACCEPTED ? true : false,
      partner1Location: firebasePartnerAddress,
      partner2Location: firebaseUserAddress,
      date: new Date(),
    }
    props.saveSuggestionEvent(suggestedValue)
  }

  const onSuggestionAction = (action) => async () => {
    if (action === SUGGESTION_STATES.ACCEPTED) {
      //check if address is deliverable, only then accept suggestion and move to meal
      await props.validateUserAddress(
        firebaseUserAddress,
        _.get(suggestedRestaurant, "restaurantId", ""),
        () => firebaseActions(action)
      )
    } else {
      //if suggestion is rejected set firebase state
      await FirebaseService.patch(
        {
          [FIREBASE_STATE_KEYS.SUGGESTION_STATE]: action,
        },
        `${FirebaseService.getDefaultPath()}${partner.uuid}/${[
          FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT,
        ]}`
      )
      //save to admin dashboard on reject
      saveToAdminDashboard(action)
    }
  }
  const partnerName = getPartnerNameorNickName(partnerState)

  const suggestedRestaurantName = _.get(
    pendingRestaurantSuggestion,
    FIREBASE_STATE_KEYS.RESTAURANT_NAME,
    ""
  )

  const showMenuModal = () => {
    emitter.fire(CUSTOM_EVENTS.SHOW_RESTAURANT_MENU, [
      pendingRestaurantSuggestion,
    ])
  }

  if (_.isEmpty(pendingRestaurantSuggestion)) return null
  return (
    <div id="SuggestedRestaurant">
      <div id="Suggestor">
        <p>{partnerName} suggested </p>
        <button id="restaurantName" onClick={showMenuModal}>
          {suggestedRestaurantName}
        </button>
      </div>
      <div id="responseButtons">
        <AcceptSuggestionButton
          suggesting={suggesting}
          accepted={onSuggestionAction(SUGGESTION_STATES.ACCEPTED)}
          setSuggestion={setSuggestion}
        />
        <DeclineSuggestionButton
          declined={onSuggestionAction(SUGGESTION_STATES.REJECTED)}
        />
      </div>

      {/* <div style={{ color: "grey" }}>
        {CUISINE_LABEL}
        {restaurantMetaData.cuisines &&
          restaurantMetaData.cuisines.map((cusine, i) => (
            <span key={cusine}>
              {cusine}
              {i < restaurantMetaData.cuisines.length - 1 && ","}
            </span>
          ))}
      </div> */}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    partner: _.get(state, "auth.partner", {}),
    user: _.get(state, "auth.user", {}),
    suggesting: _.get(state, "loadingState.suggesting"),
  }
}

export default connect(mapStateToProps, {
  acceptSuggestion,
  declineSuggestion,
  saveSuggestionEvent,
  setSuggestion,
  validateUserAddress,
})(withRouter(SuggestedRestaurant))
